// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__OxM2R","isHovering":"Footer_isHovering__4vL1M","brand":"Footer_brand__qEe2A","longText":"Footer_longText__jLHb5","copyright":"Footer_copyright__VHDui"};